import { render, staticRenderFns } from "./LanguageButton.vue?vue&type=template&id=bf38ae1a"
import script from "./LanguageButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports